// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/modules/products/v2_0/components/FeaturesSpecs/featuresSpecs.scss
// module id = 1423
// module chunks = 10 21